var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "rt-switch__wrapper": true, "price-switch": _vm.priceMode } },
    [
      _c(
        "div",
        {
          staticClass: "rt-switch__label-wrapper",
          class: { "has-tooltip": _vm.tooltipVisible },
        },
        [
          _vm.label
            ? _c("div", { staticClass: "rt-switch__label" }, [
                _vm._v(_vm._s(_vm.label)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tooltipVisible
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: {
                        content: _vm.tooltip,
                        trigger: "hover click",
                      },
                      expression:
                        "{\n              content: tooltip,\n              trigger: 'hover click'\n          }",
                    },
                  ],
                  staticClass: "tooltip-wrapper",
                },
                [
                  _c("rt-picture", {
                    staticClass: "icon-help",
                    attrs: { src: "/assets/app/class/icon-help.svg" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showPremium
            ? _c("rt-picture", {
                staticClass: "icon-premium",
                attrs: { src: "/assets/app/navigation/icon-diamond.svg" },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "switchControl",
          class: { "rt-switch__control-wrapper": true, active: _vm.value },
          on: { click: _vm.onClickSwitchControl },
        },
        [
          !_vm.priceMode
            ? _c("span", {
                class: { "rt-switch__circle": true, active: _vm.value },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.value || _vm.priceMode
            ? _c("span", { staticClass: "rt-switch__control-label on" }, [
                _vm._v(_vm._s(_vm.activeLabel)),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.value || _vm.priceMode
            ? _c("span", { staticClass: "rt-switch__control-label off" }, [
                _vm._v(_vm._s(_vm.invactiveLavel)),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        ref: "switch",
        attrs: { type: "checkbox", name: _vm.name, hidden: "" },
        domProps: { checked: _vm.value },
        on: { input: _vm.handleInputCheck },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }